import ModalExample from '../Modal/ModalExample.jsx';

//Sources
import AboutSourcesGda from './AboutSections/AboutSourcesGda.jsx';
import AboutSourcesVda from './AboutSections/AboutSourcesVda.jsx';
import AboutSourcesDda from './AboutSections/AboutSourcesDda.jsx';

//Metrics
import AboutMetricsGdaScore from './AboutSections/Metrics/AboutMetricsGdaScore.jsx';
import AboutMetricsVdaScore from './AboutSections/Metrics/AboutMetricsVdaScore.jsx';
import AboutMetricsSpecificity from './AboutSections/Metrics/AboutMetricsSpecificity.jsx';
import AboutMetricsPleiotropy from './AboutSections/Metrics/AboutMetricsPleiotropy.jsx';
import AboutMetricsEvidenceIndex from './AboutSections/Metrics/AboutMetricsEvidenceIndex.jsx';

//Diseases
import DiseaseType from './AboutSections/Attributes/Diseases/DiseaseType.jsx';
import DO from './AboutSections/Attributes/Diseases/DO.jsx';
import MeSHDiseaseClass from './AboutSections/Attributes/Diseases/MeSHDiseaseClass.jsx';
import HPO from './AboutSections/Attributes/Diseases/HPO.jsx';

//Gene Disease
import FirstRef from './AboutSections/Attributes/GeneDisease/FirstRef.jsx';
import LastRef from './AboutSections/Attributes/GeneDisease/LastRef.jsx';
import OriginalDB from './AboutSections/Attributes/GeneDisease/OriginalDB.jsx';
import EvidenceLevel from './AboutSections/Attributes/GeneDisease/EvidenceLevel.jsx';

//Genes
import GenespLI from './AboutSections/Attributes/Genes/GenespLI.jsx';
import GenesProteinClass from './AboutSections/Attributes/Genes/GenesProteinClass.jsx';
import GenesUniProt from './AboutSections/Attributes/Genes/GenesUniProt.jsx';

//Variants
import Position from './AboutSections/Attributes/Variants/Position.jsx';
import Type from './AboutSections/Attributes/Variants/Type.jsx';
import RiskAllele from './AboutSections/Attributes/Variants/RiskAllele.jsx';
import Consequence from './AboutSections/Attributes/Variants/Consequence.jsx';
import Alleles from './AboutSections/Attributes/Variants/Alleles.jsx';
import GenomeExome from './AboutSections/Attributes/Variants/Genome-Exome.jsx';

//Variant Disease
import PMID from './AboutSections/Attributes/VarianDiseases/PMID.jsx';
import PValue from './AboutSections/Attributes/VarianDiseases/PValue.jsx';

function HelpPopups({
  // Sources
  showGDA,
  setShowGDA,
  showVDA,
  setShowVDA,
  showDDA,
  setShowDDA,

  // Metrics
  showScore,
  setShowScore,
  showDSI,
  setShowDSI,
  showDPI,
  setShowDPI,
  showEI,
  setShowEI,

  // Diseases
  showDiseaseType,
  setShowDiseaseType,
  showMeSH,
  setShowMeSH,
  showDO,
  setShowDO,
  showHPO,
  setShowHPO,

  // Genes
  showpLI,
  setShowpLI,
  showProteinClass,
  setShowProteinClass,
  showUniProt,
  setShowUniProt,

  // Variants
  showVariantPosition,
  setShowVariantPosition,
  showVariantType,
  setShowVariantType,
  showVariantRiskAllele,
  setShowVariantRiskAllele,
  showVariantConsequence,
  setShowVariantConsequence,
  showAlleles,
  setShowAlleles,
  showGenomeExome,
  setShowGenomeExome,

  // Gene-Disease Associations && Variant-Disease Associations
  showFirstRef,
  setShowFirstRef,
  showLastRef,
  setShowLastRef,
  showEvidenceLevel,
  setShowEvidenceLevel,
  showOriginalDB,
  setShowOriginalDB,
  showPMID,
  setShowPMID,
  showpValue,
  setShowpValue,
}) {
  return (
    <>
      {/* Sources */}

      <ModalExample
        open={showGDA}
        setOpen={setShowGDA}
        title="Gene-Disease Associations (GDA)"
        content={<AboutSourcesGda />}
      />

      <ModalExample
        open={showVDA}
        setOpen={setShowVDA}
        title="Variant-Disease Associations (VDA)"
        content={<AboutSourcesVda />}
      />

      <ModalExample
        open={showDDA}
        setOpen={setShowDDA}
        title="Drug-Disease Associations (DDA)"
        content={<AboutSourcesDda />}
      />

      {/* Metrics */}

      <ModalExample
        open={showScore}
        setOpen={setShowScore}
        content={
          <>
            <AboutMetricsGdaScore />
            <AboutMetricsVdaScore />
          </>
        }
      />

      <ModalExample open={showDSI} setOpen={setShowDSI} content={<AboutMetricsSpecificity />} />

      <ModalExample open={showDPI} setOpen={setShowDPI} content={<AboutMetricsPleiotropy />} />

      <ModalExample open={showEI} setOpen={setShowEI} content={<AboutMetricsEvidenceIndex />} />

      {/* Data Attributes Diseases */}

      <ModalExample
        open={showDiseaseType}
        setOpen={setShowDiseaseType}
        title="Disease Type"
        content={<DiseaseType />}
      />

      <ModalExample open={showDO} setOpen={setShowDO} title="Disease Ontology (DO)" content={<DO />} />

      <ModalExample
        open={showHPO}
        setOpen={setShowHPO}
        title="Human Phenotype Ontology (HPO)"
        content={<HPO />}
      />

      <ModalExample
        open={showMeSH}
        setOpen={setShowMeSH}
        title="MeSH Disease Class"
        content={<MeSHDiseaseClass />}
      />

      {/* Data Attributes Genes */}

      <ModalExample open={showpLI} setOpen={setShowpLI} title="pLI" content={<GenespLI />} />

      <ModalExample
        open={showProteinClass}
        setOpen={setShowProteinClass}
        title="Protein classification"
        content={<GenesProteinClass />}
      />

      <ModalExample open={showUniProt} setOpen={setShowUniProt} title="UniProt" content={<GenesUniProt />} />

      {/* Data Attributes Variants */}

      <ModalExample
        open={showVariantPosition}
        setOpen={setShowVariantPosition}
        title="Varian Position"
        content={<Position />}
      />

      <ModalExample
        open={showVariantType}
        setOpen={setShowVariantType}
        title="Variant Type"
        content={<Type />}
      />

      <ModalExample open={showAlleles} setOpen={setShowAlleles} title="Alleles" content={<Alleles />} />

      <ModalExample
        open={showVariantRiskAllele}
        setOpen={setShowVariantRiskAllele}
        title="Risk Allele"
        content={<RiskAllele />}
      />

      <ModalExample
        open={showVariantConsequence}
        setOpen={setShowVariantConsequence}
        title="Consequence Type"
        content={<Consequence />}
      />

      <ModalExample
        open={showGenomeExome}
        setOpen={setShowGenomeExome}
        title="AF Genomes - Exomes"
        content={<GenomeExome />}
      />

      {/* Data Attributes Gene-Disease Associations && Data Attributes Variant-Disease Associations */}

      <ModalExample
        open={showFirstRef}
        setOpen={setShowFirstRef}
        title="First Reference"
        content={<FirstRef />}
      />

      <ModalExample
        open={showLastRef}
        setOpen={setShowLastRef}
        title="Last Reference"
        content={<LastRef />}
      />

      <ModalExample
        open={showEvidenceLevel}
        setOpen={setShowEvidenceLevel}
        title="Evidence Level for the GDA"
        content={<EvidenceLevel />}
      />

      <ModalExample
        open={showOriginalDB}
        setOpen={setShowOriginalDB}
        title="Original Database"
        content={<OriginalDB />}
      />

      <ModalExample open={showPMID} setOpen={setShowPMID} title="PubMed Identifier" content={<PMID />} />

      <ModalExample
        open={showpValue}
        setOpen={setShowpValue}
        title="P-value of the GWAS"
        content={<PValue />}
      />
    </>
  );
}

export default HelpPopups;
